import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import ViewModel from '@bingads-webui-campaign-legacy/crud-adgroup/viewmodel/keywordPlannerAdvanced';
import tmpl from '@bingads-webui-campaign-legacy/crud-adgroup/template/keywordPlannerAdvanced.pug';
import * as keywordPlannerCreateOptions from '@bingads-webui-campaign-legacy/crud-adgroup/viewmodel/keywordPlannerCreateOptions';
import pgrid from '@bingads-webui-component-legacy/github/modules/projection-grid/module/projection-grid';
import { bingadsGridColumn } from '@bingads-webui-component-legacy/bingads-grid/shared/column';
import popup from '@bingads-webui-component-legacy/dialog/popup';
import { getSearchRangeString } from '../share/getSearchRange';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;

    if (!_.isUndefined(options.AdGroups)) {
      let unnameCounter = 0;

      options.AdGroups = _.map(options.AdGroups, (ag) => {
        const isUnnamed = ag.name() === '';

        return _.extend({}, ag, {
          checked: ko.observable(false),
          isUnnamed,
          defaultName: ko.observable(isUnnamed ? `${i18n.get('KeywordPlanner_NoNameAdgroup_DefaultName')} ${++unnameCounter}` : ''),
        });
      });
    }

    this.viewmodel = new ViewModel(options);
  }

  get events() {
    return {
      'click .apply-to-adgroups': 'applyToAdgroups',
      'click .add-to-new-adgroup': 'addToNewAdgroup',
      'click .add-to-all-adgroups': 'addToAllAdgroups',
      'click .add-to-some-adgroups': 'addToSomeAdgroups',
      'click .cancel-panel': 'cancelPanel',
    };
  }

  render() {
    this.$el.html(tmpl({
      i18n,
    }));

    ko.applyBindings(this.viewmodel, this.el);

    this.grid = pgrid.factory({ vnext: true })
      .create({
        tableClasses: ['table', 'table-hover', 'grid', 'grid-table'],
        dataSource: {
          type: 'memory',
          data: this.viewmodel.gridData,
        },
        rows: {
          bodyRows: [{
            type: 'data-rows',
            classes: ['table__row--keyword-planner'],
          }],
        },
        columns: this.getColumns(),
        selection: {
          enabled: true,
          a11y: {
            selectAllLabel: i18n.getString('KeywordPlanner_GridColumn_SelectAll'),
          },
        },
      });

    this.grid.gridView.render();
    this.$('.grid-container').append(this.grid.gridView.el);
    return this;
  }

  getColumns() {
    return _.map([
      {
        name: 'name',
        title: i18n.getString('KeywordPlanner_GridColumn_Suggestions'),
        type: 'string',
        sortable: true,
        property: (item) => item.Keyword,
      },
      {
        name: 'searchCount',
        title: i18n.getString('KeywordPlanner_GridColumn_MonthlySearches'),
        helpId: 'pop_BA_CampaignCreate_Keywords_MonthlySearches',
        type: 'string',
        sortable: true,
        headClasses: ['text-right'],
        bodyClasses: ['text-right'],
        property: (item) => getSearchRangeString(item.AggregateMetric.AverageSearchVolume, i18n.realI18n),
      },
      {
        name: 'averageCPC',
        title: i18n.getString('KeywordPlanner_GridColumn_AverageCPC'),
        helpId: 'pop_BA_CampaignCreate_Keywords_AvgCPC',
        type: 'number',
        sortable: true,
        headClasses: ['text-right'],
        bodyClasses: ['text-right'],
        property: (item) => item.AggregateMetric.AverageCPC,
      },
      {
        name: 'competition',
        title: i18n.getString('KeywordPlanner_GridColumn_Competition'),
        helpId: 'pop_BA_CampaignCreate_Keywords_Competition',
        type: 'string',
        sortable: true,
        headClasses: ['text-right'],
        bodyClasses: ['text-right'],
        property: (item) => i18n.get(`CompetitionLevel_${item.AggregateMetric.CompetitionLevel}`),
      },
    ], bingadsGridColumn);
  }

  get selectedKeywords() {
    const checkedRowIds = _.pluck(this.grid.gridView.selectedItems(), 'Keyword');
    const checkedKeywords = [];

    _.each(checkedRowIds, (id) => {
      checkedKeywords.push(_.find(this.viewmodel.gridData, (kw) => {
        return kw.Keyword === id;
      }));
    });

    return checkedKeywords;
  }

  applyToAdgroups(event) {
    if (this.selectedKeywords.length === 0) {
      this.noRowSelected(event);
    }
  }

  addToNewAdgroup() {
    this.viewmodel.suggestedAdgroup.Suggestions = this.selectedKeywords;
    this.trigger('addAdgroup', {
      sourceReqId: this.options.sourceReqId,
      data: this.viewmodel.suggestedAdgroup,
      mode: keywordPlannerCreateOptions.AddToNewAdGroup,
    });
  }

  addToAllAdgroups() {
    this.viewmodel.suggestedAdgroup.Suggestions = this.selectedKeywords;
    this.trigger('addAdgroup', {
      sourceReqId: this.options.sourceReqId,
      data: this.viewmodel.suggestedAdgroup,
      mode: keywordPlannerCreateOptions.AddToAllAdGroups,
    });
  }

  addToSomeAdgroups(event) {
    this.viewmodel.suggestedAdgroup.Suggestions = this.selectedKeywords;
    let selectedAdgroups = _.filter(this.viewmodel.adgroups(), (ag) => {
      return ag.checked() === true;
    });

    if (selectedAdgroups.length === 0) {
      this.noRowSelected(event);
      return;
    }
    this.trigger('addAdgroup', {
      sourceReqId: this.options.sourceReqId,
      data: this.viewmodel.suggestedAdgroup,
      mode: keywordPlannerCreateOptions.AddToSelectedAdGroups,
      selectedAdgroups: _.map(selectedAdgroups, (ag) => {
        return _.omit(ag, ['checked', 'isUnnamed', 'defaultName']);
      }),
    });
  }

  cancelPanel() {
    this.trigger('cancel');
  }

  noRowSelected(event) {
    event.stopPropagation();
    popup.alert(i18n.get('Grid_RowSelectionRequired'));
  }
}
